import { createStore } from "vuex";
import axios from "axios";
import { Toast } from "vant";

/**
 * 提示函数
 * 禁止点击蒙层、显示一秒后关闭
 */
axios.defaults.withCredentials = true;
const tip = (msg) => {
  Toast({
    message: msg,
    duration: 1000,
    forbidClick: true,
  });
};

// const api_prefix = "/api/wish/";
// const api = "/api/comhelp/";
// baseURL
let baseURL;
if (process.env.NODE_ENV !== "production") {
  baseURL = "api/comhelp";
} else {
  baseURL = "https://zsrbactivity.zsnews.cn";
}

console.log("baseURL", baseURL);
export default createStore({
  state: {
    showStatement: false,
    jsBridgePackage: {},
    qaContents: [],
    adviceContents: [],
    tipoffContents: [],
    user: {},
    detail: {},
    envData: {},
    covers: [],
    newsData: [],
    myContentData: [],
    myCommentData: [],
    tabActive: "",
    detailCategory: "",
    statement: "",
    exinfo: "",
  },
  mutations: {
    updateEnvData(state, envData) {
      state.envData = envData;
      state.covers = envData.covers;
      state.exinfo = envData.exinfo;
      state.apkLink = envData.apkLink;
      state.statement = envData.statement;
    },
    updateShowStatement(state, showStatement) {
      state.showStatement = showStatement;
    },
    deleteContentData(state, category) {
      if (category == "advice") {
        state.adviceContents = [];
      } else if (category == "qa") {
        state.qaContents = [];
      } else {
        state.tipoffContents = [];
      }
    },

    updateContentData(state, [contents, category]) {
      console.log("contents", contents);
      contents.forEach((item) => {
        if (item.images && item.images.length > 0) {
          item.buttonType = "default";
        }
      });
      if (category == "advice") {
        state.adviceContents = state.adviceContents.concat(contents);
      } else if (category == "qa") {
        state.qaContents = state.qaContents.concat(contents);
      } else {
        state.tipoffContents = state.tipoffContents.concat(contents);
      }
    },
    initNewsData(state, contents) {
      console.log(contents);
      contents.forEach((item) => {
        if (item.images && item.images.length > 0) {
          // item.images = item.images.split(",");
          item.buttonType = "default";
        }
      });
      state.newsData = state.newsData.concat(contents);
      console.log("contents", state.contents);
    },
    //我的报料
    initMyContentData(state, contents) {
      console.log(contents);
      contents.forEach((item) => {
        if (item.images && item.images.length > 0) {
          // item.images = item.images.split(",");
          item.buttonType = "default";
        }
        if (item.category === "tipoff") item.categoryText = "投诉监督";
        else if (item.category === "advice") item.categoryText = "建言献策";
      });
      state.myContentData = state.myContentData.concat(contents);
    },
    // 我的评论
    initMyCommentData(state, comments) {
      comments.forEach((item) => {
        if (item.images && item.images.length > 0) {
          // item.images = item.images.split(",");
          item.buttonType = "default";
        }
      });
      state.myCommentData = state.myCommentData.concat(comments);
    },
    updateContents(state, [index, data]) {
      if (data.type == "qa") {
        const content = state.qaContents[index];
        content.like = data.like;
        content.buttonType = "danger";
        state.qaContents[index] = content;
      } else if (data.type == "advice") {
        const content = state.adviceContents[index];
        content.like = data.like;
        content.buttonType = "danger";
        state.adviceContents[index] = content;
      } else if (data.type == "tipoff") {
        const content = state.tipoffContents[index];
        content.like = data.like;
        content.buttonType = "danger";
        state.tipoffContents[index] = content;
      }
    },
    contentDetail(state, detail) {
      if (detail.images && detail.images.length > 0)
        // detail.images = detail.images.split(",");
        detail.comments.forEach((comment) => {
          comment.buttonType = "default";
        });
      console.log("detail", detail);
      state.detail = detail;
      state.detailCategory = detail.category;
    },
    updateDetail(state, [index, data, params, buttonType]) {
      console.log("params", params);
      if (params.type == 2) {
        const comment = state.detail.comments[index];
        comment.like = data.like;
        comment.buttonType = "danger";
        state.detail.comments[index] = comment;
      } else if (params.type == 3) {
        const reply = state.detail.replys[index];
        reply.like = data.like;
        reply.buttonType = "danger";
        state.detail.replys[index] = reply;
      } else if (buttonType) {
        state.detail.like = data.like;

        // state.contents.forEach((content) => {
        //   if (content.id == params.id) {
        //     content.like = like;
        //   }
        // });
      }
    },
    updateJsBridgePackage(state, jsBridgePackage) {
      state.jsBridgePackage = jsBridgePackage;
    },
    updateUser(state, user) {
      state.user = user;
      const { aplus_queue } = window;
      aplus_queue.push({
        action: "aplus.setMetaInfo",
        arguments: ["_user_id", user.user_id],
      });
    },
  },
  actions: {
    // 活动基础信息 /api/comhelp/index
    getAppEnv({ commit }) {
      axios
        .get(baseURL + "/api/comhelp/index")
        .then((res) => {
          if (res.status === 200) {
            const data = res.data;
            console.log(data);
            if (data.code === 1) {
              commit("updateEnvData", data.data);
            } else {
              tip(data.msg);
            }
          } else {
            tip("网络错误，请重试");
          }
        })
        .catch(() => {
          tip("网络错误，请重试");
        });
    },
    getZsplusJsBrigde({ commit }) {
      return new Promise((resolve) => {
        axios
          .get("https://zsrbactivity.zsnews.cn/api/common/zsrbjsbrigeconfig")
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code === 1) {
                commit("updateJsBridgePackage", data.data);
                resolve(data.data);
              } else {
                tip(data.msg);
              }
            } else {
              tip("网络错误，请重试");
            }
          })
          .catch(() => {
            tip("网络错误，请重试");
          });
      });
    },
    loginByZsplus({ commit }, info) {
      return new Promise((resolve) => {
        axios
          .post("https://zsrbactivity.zsnews.cn/api/common/zsplusauth", {
            sessionToken: info.sessionToken,
            head: info.head,
            nickName: info.nickName,
            phone: info.phone,
            gender: info.gender,
          })
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code == 1) {
                // 存储中山+授权用户信息
                commit("updateUser", data.data);
                sessionStorage.setItem("zsplusInfo", JSON.stringify(data.data));
                // info.nickName info.head info.sessionToken info.gender info.phone
                resolve();
              } else if (data.code == 2) {
                //sessionToken过期,需要配合iOS端做统一处理
                tip(data.msg);
              } else {
                tip(data.msg);
              }
            } else {
              tip("网络错误，请重试");
            }
          });
      });
    },
    loginByWx({ commit }, code) {
      return new Promise((resolve) => {
        axios
          .get("https://zsrbactivity.zsnews.cn/api/common/wechatoath", {
            params: { code },
          })
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code == 1) {
                // 存储微信授权用户信息
                commit("updateUser", data.data);
                sessionStorage.setItem("wxInfo", JSON.stringify(data.data));
                sessionStorage.setItem("nickName", data.data.nickname);
                resolve();
              } else {
                tip(data.msg);
              }
            }
          })
          .catch(() => {
            tip("网络错误，请重试");
          });
      });
    },
    // 帮办内容列表
    getContentList({ commit }, { params, loading, finished, refreshing }) {
      axios
        .get(baseURL + "/api/comhelp/contentList", {
          params: params,
        })
        .then((res) => {
          loading.value = false;

          if (refreshing.value || params.page == 1) {
            commit("deleteContentData", params.category);
            refreshing.value = false;
          }

          if (res.data.code === 1) {
            const data = res.data;

            if (data.data.length < 20) {
              finished.value = true;
            } else {
              finished.value = false;
            }

            commit("updateContentData", [data.data, params.category]);
          } else {
            tip("网络错误，请重试1");
          }
        })
        .catch((err) => {
          console.log(err);
          tip("网络错误，请重试2");
        });
    },
    // 帮办详情
    contentDetail({ commit }, params) {
      axios
        // .get(process.env.baseURL + api + "contentDetail", {
        .get(baseURL + "/api/comhelp/contentDetail", {
          params: params,
        })
        .then((res) => {
          if (res.data.code === 1) {
            const data = res.data;
            commit("contentDetail", data.data[0]);
          } else {
            tip("网络错误，请重试");
          }
        })
        .catch(() => {
          tip("网络错误，请重试");
        });
    },
    // 媒体追踪
    getNewsList({ commit, state }, { params, loading, finished, refreshing }) {
      console.log(111, params);
      axios
        .get(baseURL + "/api/comhelp/newsList", {
          params: params,
        })
        .then((res) => {
          loading.value = false;

          if (refreshing.value || params.page == 1) {
            state.newsData = [];
            refreshing.value = false;
          }

          if (res.data.code === 1) {
            const data = res.data;

            if (data.data.length < 20) {
              finished.value = true;
            } else {
              finished.value = false;
            }
            commit("initNewsData", data.data);
          } else {
            tip("网络错误，请重试");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 我的报料 登录
    myContent({ commit, state }, { params, loading, finished, refreshing }) {
      axios
        .get(baseURL + "/api/comhelp/myContent", {
          params: params,
        })
        .then((res) => {
          loading.value = false;

          if (refreshing.value || params.page == 1) {
            state.myContentData = [];
            refreshing.value = false;
          }

          if (res.status === 200) {
            if (res.data.code === 1) {
              const data = res.data;

              if (data.data.length < 20) {
                finished.value = true;
              } else {
                finished.value = false;
              }
              commit("initMyContentData", data.data);
            }
          } else {
            Toast.fail("网络错误，请重试");
          }
        })
        .catch(() => {
          Toast.fail("网络错误，请重试");
        });
    },
    // 我的评论 登录
    myComment({ commit, state }, { params, loading, finished, refreshing }) {
      axios
        .get(baseURL + "/api/comhelp/myComment", {
          params: params,
        })
        .then((res) => {
          loading.value = false;

          if (refreshing.value || params.page == 1) {
            state.myCommentData = [];
            refreshing.value = false;
          }

          if (res.status === 200) {
            if (res.data.code === 1) {
              const data = res.data;

              if (data.data.length < 20) {
                finished.value = true;
              } else {
                finished.value = false;
              }

              commit("initMyCommentData", data.data);
            }
          } else {
            Toast.fail("网络错误，请重试");
          }
        })
        .catch(() => {
          Toast.fail("网络错误，请重试");
        });
    },
    // 评论 登录
    comment({ state }, value) {
      console.log(state);
      return new Promise((resolve, reject) => {
        axios
          .post(baseURL + "/api/comhelp/comment", value)
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code === 1) {
                Toast.success(data.msg);
                resolve();
              } else {
                Toast.fail(data.error);
                reject();
              }
            } else {
              Toast.fail("网络错误，请重试");
              reject();
            }
          })
          .catch(() => {
            Toast.fail("网络错误，请重试");
            reject();
          });
      });
    },
    // 上传帮办
    submit({ state }, values) {
      console.log(state);
      if (values["fileList"].length != 0) {
        const reducer = (accumulator, currentValue) =>
          accumulator + "," + currentValue;
        const maper = (item) => item.url;
        values["fileList"] = values["fileList"].map(maper).reduce(reducer);
      } else {
        values["fileList"] = null;
      }
      if (values["category"] === "投诉监督") values["category"] = "tipoff";
      else if (values["category"] === "建言献策") values["category"] = "advice";
      console.log(values["category"]);
      return new Promise((resolve, reject) => {
        axios
          .post(baseURL + "/api/comhelp/submit", values)
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code === 1) {
                resolve(data.msg);
              } else {
                Toast.fail(data.msg);
              }
            } else {
              reject();
              Toast.fail("网络错误，请重试");
            }
          })
          .catch(() => {
            reject();
            Toast.fail("网络错误，请重试");
          });
      });
    },
    // 帮办点赞 登录
    contentLike({ commit }, { params, index, buttonType }) {
      axios
        .post(baseURL + "/api/comhelp/like", params)
        .then((res) => {
          if (res.data.code === 1) {
            const data = res.data;
            console.log(params.type);
            console.log(index);
            if (params.type === 1) {
              if (buttonType) {
                buttonType.value = "danger";
                commit("updateDetail", [index, data.data, params, buttonType]);
              } else {
                commit("updateContents", [index, data.data]);
              }
            } else {
              commit("updateDetail", [index, data.data, params]);
            }
          } else {
            console.log(1111);
            tip("网络错误，请重试");
          }
        })
        .catch(() => {
          tip("网络错误，请重试");
        });
    },
  },

  modules: {},
});
